import CameraPreview from '@/views/detector/CameraPreview/CameraPreview.vue';
import ModalPreview from '@/components/shared/ModalPreview/ModalPreview.vue';
import ImageListView from '@/views/detector/ImageListView/ImageListView.vue';
import ImageSelection from '@/views/detector/ImageSelection/ImageSelection.vue';
import dayjs from 'dayjs';
import showToast from '@/util/toast';
import { showConfirmSwal } from '@/util/swal';

import { createNamespacedHelpers } from 'vuex';
import socketClusterService from '../../../services/socket.service';
import { WS_UPDATE_MODEL } from '../../../util/constants';
const globalMapper = createNamespacedHelpers('global');
const authMapper = createNamespacedHelpers('global/auth');
const historyImageMapper = createNamespacedHelpers('history/image');
const detectorMapper = createNamespacedHelpers('detector');
const modelMapper = createNamespacedHelpers('detector/model');
const imageMapper = createNamespacedHelpers('detector/image');
const cameraMapper = createNamespacedHelpers('detector/camera');
const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');
const imageSelectionImageMapper = createNamespacedHelpers('imageSelection/image');
const DETECTED_IMAGE_LIMIT = 10;
const SUFFIX = 'detector';
const TIME_RECENT = 0;

export default {
	components: {
		ModalPreview,
		CameraPreview,
		ImageListView,
		ImageSelection,
	},

	data() {
		return {
			threshold: 0.5,
			pageTitle: this.$t('appName'),
			slidePoint: 0,
			modalId: 'detectorModels',
			onChooseDeleteModel: '',
			detectorLocalModel: '',
			suffix: SUFFIX,
			SELECT_IMAGE_FROM_CLOUD: 0,
			screenWidth: window.innerWidth,
			isPermissionCamera: false,
			displayModel: undefined,
		};
	},

	computed: {
		...authMapper.mapState(['username']),
		...modelMapper.mapState(['model', 'models']),
		...imageMapper.mapState(['images']),
		...cameraMapper.mapState(['auto']),
		...advancedSettingMapper.mapState(['advancedSetting']),
		auto: {
			get() {
				return this.$store.state.detector.camera.auto;
			},
			set() {
				this.$store.dispatch('detector/camera/switchAuto');
			},
		},

		front: {
			get() {
				return this.$store.state.detector.camera.front;
			},
			set() {
				this.$store.dispatch('detector/camera/switchMode');
			},
		},

		focus: {
			get() {
				return this.$store.state.detector.camera.focus;
			},
			set() {
				this.$store.dispatch('detector/camera/toggleCrosshair');
			},
		},

		choosenDeleteModel() {
			return this.onChooseDeleteModel;
		},

		confirmDeleteModel() {
			return {
				title: this.$t('confirnDelete'),
				text: `Model ${this.choosenDeleteModel} ${this.$t('deleteModelText')}`,
				yesButton: this.$t('confirmYes'),
				noButton: this.$t('confirmNo'),
			};
		},

		/**
		 * check if localstorage save model at the last time
		 */
		modelLocalExisted() {
			return this.detectorLocalModel ? true : false;
		},

		/**
		 * get model name from localstorage if it existed, choose it, else choose default model
		 */
		startingModel() {
			let detectorSavedModel = localStorage.getItem(`${this.username}-${this.suffix}`);
			return !this.modelLocalExisted
				? this.model
				: this.models.some((model) => model.model_name === detectorSavedModel)
				? detectorSavedModel
				: this.model;
		},

		notFound() {
			return this.$t('notFound');
		},

		/**
		 * return model name to display or not found if model is empty
		 */
		displayedModel() {
			let model = this.models.find(({ model_name }) => model_name === this.model);

			if (model !== undefined) {
				this.displayModel = model.display.model_name;
				this.SET_DISPLAY_CROSS_HAIR(model.display.crosshair);
			}

			return this.displayModel || this.notFound;
		},

		/**
		 * check if model is empty or not to disable button
		 */
		buttonDisabled() {
			return !this.model;
		},
	},

	methods: {
		...globalMapper.mapActions(['setSpinner']),
		...modelMapper.mapActions(['retrieveModels', 'setModel', 'deleteModel']),
		...modelMapper.mapMutations(['SET_DISPLAY_CROSS_HAIR']),
		...imageMapper.mapActions(['retrieveImages']),
		...detectorMapper.mapActions(['loadModel']),
		...historyImageMapper.mapMutations(['SET_DATE_START', 'SET_DATE_END']),
		...imageSelectionImageMapper.mapMutations(['SET_IMAGES']),

		onClickModelsListBtn() {
			this.$bvModal.show(this.modalId);
			this.$off('focus', this.handleButtonFocus);
		},

		handleButtonFocus() {
			console.log('Button focused!');
		},
		handleResize() {
			this.screenWidth = window.innerWidth;
		},

		onSelectImage() {
			this.$bvModal.show('imageSelectionModalId');

			this.SET_IMAGES([]);
		},

		async onDeleteModel(model) {
			console.log({ model });
			this.onChooseDeleteModel = model.model_name;

			const confirm = async () => {
				try {
					console.log('confirm');

					await this.deleteModel({
						username: model.username,
						model_name: model.model_name,
						model_id: model._id?.$oid,
					});

					console.log('deleted');

					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('successLoadModel'),
					});

					await this.retrieveModels({ username: this.username });
					localStorage.setItem(`${this.username}-${this.suffix}`, this.startingModel);

					await this.retrieveImages({
						username: this.username,
						model: this.startingModel,
						limit: DETECTED_IMAGE_LIMIT,
					});
					this.loadModel({
						username: this.username,
						model: this.startingModel,
						threshold: this.threshold,
					});
				} catch (error) {
					console.log({ error });
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('failLoadModel'),
					});
				}
			};
			const dismiss = async () => {
				console.log('dimiss');
			};

			showConfirmSwal(this.confirmDeleteModel, confirm, dismiss);
		},

		async onSelectModel(modelName) {
			console.log('onSelectModel', modelName);
			this.setSpinner(true);
			this.setModel({ model: modelName });
			this.$store.dispatch('history/model/setModel', { model: modelName });
			localStorage.setItem(`${this.username}-${this.suffix}`, this.model);
			this.detectorLocalModel = localStorage.getItem(`${this.username}-${this.suffix}`);

			try {
				await Promise.all([
					this.loadModel({
						username: this.username,
						model: modelName,
						threshold: this.threshold,
					}),

					this.retrieveImages({
						username: this.username,
						model: this.model,
						limit: DETECTED_IMAGE_LIMIT,
					}),
				]);
				showToast({
					vueInstance: this,
					type: 'success',
					message: this.$t('successLoadModel'),
				});
			} catch (error) {
				showToast({
					vueInstance: this,
					type: 'danger',
					message: this.$t('failLoadModel'),
				});
			}

			// this.getTimeRecent();

			this.setSpinner(false);
			this.$bvModal.hide(this.modalId);
		},

		getTimeRecent() {
			const date = this.images[TIME_RECENT]?.created_at;
			const dayStartRecent = dayjs(date)
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0)
				.format('YYYY/MM/DD HH:mm:ss');

			const dayEndRecent = dayjs(date)
				.set('hour', 23)
				.set('minute', 59)
				.set('second', 59)
				.format('YYYY/MM/DD HH:mm:ss');

			this.SET_DATE_START(dayStartRecent);
			this.SET_DATE_END(dayEndRecent);
		},
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		socketClusterService.listenChannel(WS_UPDATE_MODEL, async (res) => {
			if (res?.username === username);
			await this.retrieveModels({ username: this.username });
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		this.$off('focus', this.handleButtonFocus);
	},

	async mounted() {
		this.$el.addEventListener('focus', this.handleButtonFocus);
		await this.retrieveModels({ username: this.username });

		// when there is not model, delete model saved in localstorage
		if (!this.model) {
			this.detectorLocalModel = localStorage.removeItem(
				`${this.username}-${this.suffix}`
			);
		}
		// when there is model, load model saved in localstorage
		else {
			// this.setModel({ model: this.model });
			let savedModel = localStorage.getItem(`${this.username}-${this.suffix}`);
			this.setModel({ model: savedModel ? savedModel : this.model });
			this.detectorLocalModel = savedModel;
			// localStorage.setItem(`${this.username}-${this.suffix}`, this.model);
		}

		await Promise.all([
			this.retrieveImages({
				username: this.username,
				model: this.startingModel,
				limit: DETECTED_IMAGE_LIMIT,
			}),

			this.loadModel({
				username: this.username,
				model: this.startingModel,
				threshold: this.threshold,
			}),
		]);

		const permission = await navigator.permissions.query({ name: 'camera' });
		this.isPermissionCamera = permission.state === 'granted';

		// this.getTimeRecent()
	},

	watch: {
		slidePoint: function (val) {
			this.$store.dispatch('detector/camera/setSliderPoint', val);
		},
	},
};
